const Color = {
  white: '#ffffff',
  blackLight: '#8691a6',
  blackMediumLight: '#556074',
  black: '#202635',
  redLighter: '#fceded',
  redLight: '#ffd9cf',
  redMediumLight: '#fa6666',
  red: '#e74e4e',
  redMediumDark: '#cd453d',
  redDark: '#aa342c',
  orange: '#f5a500',
  orangeDark: '#f4511e',
  greenLight: '#eaf8f0',
  green: '#2dbd6f',
  greyLight: '#fafbfd',
  grey: '#f6f7fb',
  greyDark: '#b3c0d2',
  greyDarker: '#8691a6',
  greyDarkest: '#556074',
  yellowLight: '#fff7e9',
  yellow: '#ffb829'
};

export default Color;
